<!--
  Admin mode › Flexi › Settings: HSE advisors per business.
  Every value that decides access or routing comes from the backend; this page
  only shows it and hands edits to the two dialogs below.
-->
<flexi-settings-nav></flexi-settings-nav>

<div class="fas-tabs" role="tablist" [attr.aria-label]="'FLEXI_SETTINGS.TITLE' | translate">
  <button
    #myTab
    id="fas-my-tab"
    type="button"
    role="tab"
    class="fas-tab"
    [class.fas-tab--active]="myBusinesses"
    [attr.aria-selected]="myBusinesses"
    [attr.tabindex]="myBusinesses ? 0 : -1"
    aria-controls="fas-panel"
    (click)="pickTab(true)"
    (keydown.arrowright)="$event.preventDefault(); pickTab(false); allTab.focus()"
    (keydown.arrowleft)="$event.preventDefault(); pickTab(false); allTab.focus()"
    (keydown.end)="$event.preventDefault(); pickTab(false); allTab.focus()"
  >
    {{ 'FLEXI_SETTINGS.MY_BUSINESSES' | translate }}
    <span class="fas-chip__count">{{ myWorkload?.AssignedCount || 0 }}</span>
  </button>
  <button
    #allTab
    id="fas-all-tab"
    type="button"
    role="tab"
    class="fas-tab"
    [class.fas-tab--active]="!myBusinesses"
    [attr.aria-selected]="!myBusinesses"
    [attr.tabindex]="myBusinesses ? -1 : 0"
    aria-controls="fas-panel"
    (click)="pickTab(false)"
    (keydown.arrowright)="$event.preventDefault(); pickTab(true); myTab.focus()"
    (keydown.arrowleft)="$event.preventDefault(); pickTab(true); myTab.focus()"
    (keydown.home)="$event.preventDefault(); pickTab(true); myTab.focus()"
  >
    {{ 'FLEXI_SETTINGS.ALL_BUSINESSES' | translate }}
    <span class="fas-chip__count">{{ metadata.AllCount }}</span>
  </button>
</div>

<div class="fas" id="fas-panel" role="tabpanel" [attr.aria-labelledby]="myBusinesses ? 'fas-my-tab' : 'fas-all-tab'">
  <section class="fas-main">
    <header class="fas-head">
      <div class="fas-head__text">
        <h2 class="fas-title">{{ (myBusinesses ? 'FLEXI_SETTINGS.MY_BUSINESSES' : 'FLEXI_SETTINGS.ALL_BUSINESSES') | translate }}</h2>
        <p class="fas-intro">{{ (myBusinesses ? 'FLEXI_SETTINGS.MY_INTRO' : 'FLEXI_SETTINGS.INTRO') | translate }}</p>
      </div>
      <button type="button" class="fas-btn fas-btn--primary" [disabled]="!selected.length" (click)="openBulk()">
        <i class="pi pi-user-plus" aria-hidden="true"></i>
        <span *ngIf="selected.length">{{ 'FLEXI_SETTINGS.BULK_BUTTON' | translate: { count: selected.length } }}</span>
        <span *ngIf="!selected.length">{{ 'FLEXI_SETTINGS.SELECT_TO_BULK' | translate }}</span>
      </button>
    </header>

    <div class="fas-toolbar">
      <label class="fas-search">
        <span class="fas-sr-only">{{ 'FLEXI_SETTINGS.SEARCH' | translate }}</span>
        <i class="pi pi-search" aria-hidden="true"></i>
        <input
          pInputText
          type="search"
          maxlength="200"
          [(ngModel)]="search"
          (ngModelChange)="searchChanged()"
          [placeholder]="'FLEXI_SETTINGS.SEARCH' | translate"
        />
      </label>
      <div *ngIf="myBusinesses" class="fas-filters" role="group" [attr.aria-label]="'FLEXI_SETTINGS.FILTER' | translate">
        <button type="button" class="fas-chip" [class.fas-chip--active]="primary === null" [attr.aria-pressed]="primary === null" (click)="pickPrimary(null)">
          {{ 'FLEXI_SETTINGS.FILTER_ALL' | translate }}
          <span class="fas-chip__count">{{ myWorkload?.AssignedCount || 0 }}</span>
        </button>
        <button type="button" class="fas-chip" [class.fas-chip--active]="primary === true" [attr.aria-pressed]="primary === true" (click)="pickPrimary(true)">
          {{ 'FLEXI_SETTINGS.FILTER_MY_PRIMARY' | translate }}
          <span class="fas-chip__count">{{ myWorkload?.PrimaryCount || 0 }}</span>
        </button>
        <button type="button" class="fas-chip" [class.fas-chip--active]="primary === false" [attr.aria-pressed]="primary === false" (click)="pickPrimary(false)">
          {{ 'FLEXI_SETTINGS.FILTER_MY_BACKUP' | translate }}
          <span class="fas-chip__count">{{ backupCount }}</span>
        </button>
      </div>
      <div *ngIf="!myBusinesses" class="fas-filters" role="group" [attr.aria-label]="'FLEXI_SETTINGS.FILTER' | translate">
        <button
          type="button"
          *ngFor="let filter of filters"
          class="fas-chip"
          [class.fas-chip--active]="coverage === filter.value"
          [attr.aria-pressed]="coverage === filter.value"
          (click)="pickCoverage(filter.value)"
        >
          {{ filter.labelKey | translate }}
          <span class="fas-chip__count">{{ filter.count(metadata) }}</span>
        </button>
      </div>
    </div>

    <div class="fas-error" *ngIf="loadFailed" role="alert">
      <p>{{ 'FLEXI_SETTINGS.LOAD_FAILED' | translate }}</p>
      <button type="button" class="fas-btn fas-btn--text" (click)="loadPage()">
        {{ 'FLEXI_SETTINGS.RETRY' | translate }}
      </button>
    </div>

    <div class="fas-table-card">
      <p-table
        [value]="rows"
        [(selection)]="selected"
        [selectionPageOnly]="true"
        dataKey="BusinessId"
        [paginator]="true"
        [rows]="pageSize"
        [first]="first"
        [totalRecords]="totalRecords"
        [lazy]="true"
        [lazyLoadOnInit]="false"
        (onLazyLoad)="pageChanged($event)"
        [loading]="loading"
        [tableStyle]="{ 'min-width': '52rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="fas-select-col"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
            <th>{{ 'FLEXI_SETTINGS.COLUMN_BUSINESS' | translate }}</th>
            <th>{{ 'FLEXI_SETTINGS.COLUMN_ADVISORS' | translate }}</th>
            <th>{{ 'FLEXI_SETTINGS.COLUMN_SHOWN' | translate }}</th>
            <th class="fas-edit-col"><span class="fas-sr-only">{{ 'FLEXI_SETTINGS.EDIT' | translate }}</span></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td><p-tableCheckbox [value]="row"></p-tableCheckbox></td>
            <td>
              <div class="fas-business">
                <strong>{{ row.CompanyName }}</strong>
                <span class="fas-muted">
                  {{ 'FLEXI_SETTINGS.ORG' | translate: { org: row.OrganizationNumber || '–' } }}
                  · {{ row.PortalName || ('FLEXI_SETTINGS.NO_PORTAL' | translate) }}
                </span>
              </div>
            </td>
            <td>
              <div class="fas-chips">
                <span
                  *ngFor="let advisor of row.Advisors; let i = index"
                  class="fas-advisor"
                  [class.fas-advisor--primary]="advisor.IsPrimary"
                  [class.fas-advisor--inactive]="!advisor.IsEligible"
                >
                  <span class="fas-advisor__pos">{{ i + 1 }}</span>
                  <span class="fas-advisor__name">{{ advisor.Name }}<ng-container *ngIf="advisor.UserId === currentUserId"> {{ 'FLEXI_SETTINGS.YOU' | translate }}</ng-container></span>
                  <span class="fas-badge fas-badge--primary" *ngIf="advisor.IsPrimary">{{ 'FLEXI_SETTINGS.PRIMARY' | translate }}</span>
                  <span class="fas-badge fas-badge--inactive" *ngIf="!advisor.IsEligible">{{ 'FLEXI_SETTINGS.INACTIVE' | translate }}</span>
                </span>
                <span class="fas-muted" *ngIf="!row.Advisors.length">{{ 'FLEXI_SETTINGS.NO_ADVISORS' | translate }}</span>
              </div>
            </td>
            <td [ngSwitch]="row.Coverage">
              <span *ngSwitchCase="'Ok'" class="fas-shown fas-shown--ok">
                <span class="fas-shown__who"><i class="fas-dot" aria-hidden="true"></i>{{ shownName(row) }}</span>
              </span>
              <span *ngSwitchCase="'PrimaryInactive'" class="fas-shown fas-shown--warn">
                <span class="fas-shown__who"><i class="fas-dot" aria-hidden="true"></i>{{ shownName(row) }}</span>
                <small>{{ 'FLEXI_SETTINGS.FALLS_BACK' | translate }}</small>
              </span>
              <span *ngSwitchDefault class="fas-shown fas-shown--bad">
                <span class="fas-shown__who"><i class="fas-dot" aria-hidden="true"></i>{{ 'FLEXI_SETTINGS.NOBODY' | translate }}</span>
                <small>{{ (row.Advisors.length ? 'FLEXI_SETTINGS.ALL_INACTIVE' : 'FLEXI_SETTINGS.NO_ADVISORS') | translate }}</small>
              </span>
            </td>
            <td class="fas-edit-col">
              <button
                type="button"
                class="fas-btn fas-btn--text"
                [attr.aria-label]="'FLEXI_SETTINGS.EDIT_ARIA' | translate: { name: row.CompanyName }"
                (click)="openEdit(row)"
              >
                {{ 'FLEXI_SETTINGS.EDIT' | translate }}
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5">{{ 'FLEXI_SETTINGS.NO_MATCH' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </section>

  <aside class="fas-side" [attr.aria-label]="(myBusinesses ? 'FLEXI_SETTINGS.MY_ASSIGNMENTS' : 'FLEXI_SETTINGS.WORKLOAD') | translate">
    <section *ngIf="myBusinesses" class="fas-card">
      <h3>{{ 'FLEXI_SETTINGS.MY_ASSIGNMENTS' | translate }}</h3>
      <p class="fas-muted">{{ 'FLEXI_SETTINGS.MY_ASSIGNMENTS_SUBTITLE' | translate }}</p>
      <dl class="fas-assignment-totals">
        <div>
          <dt>{{ 'FLEXI_SETTINGS.FILTER_MY_PRIMARY' | translate }}</dt>
          <dd>{{ myWorkload?.PrimaryCount || 0 }}</dd>
        </div>
        <div>
          <dt>{{ 'FLEXI_SETTINGS.FILTER_MY_BACKUP' | translate }}</dt>
          <dd>{{ backupCount }}</dd>
        </div>
      </dl>
    </section>
    <section *ngIf="!myBusinesses" class="fas-card">
      <h3>{{ 'FLEXI_SETTINGS.WORKLOAD' | translate }}</h3>
      <p class="fas-muted">{{ 'FLEXI_SETTINGS.WORKLOAD_SUBTITLE' | translate }}</p>
      <ul class="fas-workload">
        <li *ngFor="let advisor of metadata.Workload">
          <span class="fas-avatar" [class.fas-avatar--inactive]="!advisor.IsActive" aria-hidden="true">{{ initials(advisor.Name) }}</span>
          <span class="fas-workload__text">
            <strong>{{ advisor.Name }}</strong>
            <span class="fas-muted">{{ workloadSummary(advisor) }}</span>
          </span>
          <span class="fas-badge fas-badge--inactive" *ngIf="!advisor.IsActive">{{ 'FLEXI_SETTINGS.INACTIVE' | translate }}</span>
        </li>
      </ul>
    </section>
    <p class="fas-note">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>{{ 'FLEXI_SETTINGS.ACCESS_NOTE' | translate }}</span>
    </p>
  </aside>
</div>

<flexi-advisor-edit-dialog
  *ngIf="editing"
  [business]="editing"
  [selectable]="selectableAdvisors"
  (closed)="editClosed($event)"
></flexi-advisor-edit-dialog>

<flexi-advisor-bulk-dialog
  *ngIf="bulkOpen"
  [businesses]="selected"
  [selectable]="selectableAdvisors"
  (closed)="bulkClosed($event)"
></flexi-advisor-bulk-dialog>
